import React from 'react';
import { Box, Skeleton } from '@mui/material';

const BusinessStatusSkeleton = () => (
  <Box>
    {[1, 2, 3, 4].map((item) => (
      <Skeleton key={item} variant="text" />
    ))}
  </Box>
);

export default BusinessStatusSkeleton;